import { useEffect, useState } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box, List, IconButton } from '@mui/material';
import * as Muicon from '@mui/icons-material';
import { AppBar } from 'components/GlobalAppbar/AppBar';
import { GeneralIds, RoutePaths } from 'types/types';
import { ChevronLeft } from '@mui/icons-material';
import { useRecoilValue } from 'recoil';
import { GlobalDialog } from 'components/GlobalDialog/GlobalDialog';
import { GlobalConfirmDialog } from 'components/GlobalDialog/GlobalConfirmDialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { permissionState } from 'state/permissionState';
import { getIsMenuItemSelected, getMenuItems } from './utils';
import { Drawer, DrawerHeader } from './Drawer';
import SideBarItem from 'routes/Home/SideBarItem';

export type HomeMenuItem = {
  path: RoutePaths;
  name: string;
  icon: keyof typeof Muicon;
  id: string;
};

export default function Home() {
  const [open, setOpen] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const { projectId } = useParams<GeneralIds>();
  const permissions = useRecoilValue(permissionState);

  const handleDrawerOpen = () => {
    setOpen(open ? false : true);
  };

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    }
  }, [isMobile]);

  return (
    <Box>
      <GlobalDialog />
      <GlobalConfirmDialog />
      <AppBar handleDrawerOpen={handleDrawerOpen} open={open} />
      <Drawer
        variant={isMobile ? (open ? 'permanent' : 'temporary') : 'permanent'}
        open={open}
      >
        <DrawerHeader>
          <IconButton size="small" onClick={handleDrawerOpen}>
            {open && <ChevronLeft fontSize="small" sx={{ color: 'gray' }} />}
          </IconButton>
        </DrawerHeader>
        <List
          sx={{
            mt: -1,
          }}
        >
          {getMenuItems({ permissions, projectId }).map(menuItem => {
            return (
              <SideBarItem
                key={`menu-${menuItem.id}-button`}
                menuItem={menuItem}
                open={open}
                isSelected={getIsMenuItemSelected(menuItem, location.pathname, {
                  projectId,
                })}
                onClick={() => {
                  if (menuItem.id === 'logout') {
                    localStorage.removeItem('token');
                  }
                }}
              />
            );
          })}
        </List>
      </Drawer>
      <Box
        sx={{
          pt: 8,
          pl: open ? 32 : isMobile ? 2 : 10,
          pr: 2,
          pb: 2,
          width: '100%',
          transition: 'all 0.3s ease-in-out',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
